/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { AbImage } from "abreact/misc/AbImage";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";

/**
 * @deprecated in favor of either abreact/misc/AbItemProps or abreact/misc/AbLabelProps.
 */

/**
 * @deprecated in favor of either abreact/misc/AbItem or abreact/misc/AbLabel.
 */
export class AbLabel extends BaseRCmp {
  render() {
    const classes = StringUtils.cssClassStr("abweb-label", this.props.disabled ? "ab-disabled" : "", this.props.className);
    return /*#__PURE__*/React.createElement("span", {
      ref: node => this.initOuterDiv(node),
      id: this.props.id,
      className: classes,
      style: this.props.style
    }, this.renderImage(), this.renderLabel());
  }
  renderImage() {
    if (this.props.icon) {
      if (typeof this.props.icon === "string") {
        return /*#__PURE__*/React.createElement(AbImage, {
          image: this.props.icon,
          className: "abweb-icon",
          tooltip: this.props.iconTooltip
        });
      }
      return this.props.icon; //TODO iconTooltip for this case
    }
    return null;
  }
  renderLabel() {
    const hasLabel = this.props.label || this.props.children != null;
    if (!hasLabel) {
      return null;
    }
    const isRequiredClass = this.props.required === true ? "abweb-label-required" : "";
    const wrapTextClass = this.props.wrapText === true ? `abweb-label-wrap-text ${isRequiredClass}` : `abweb-label-nowrap-text ${isRequiredClass}`;
    return /*#__PURE__*/React.createElement(AbWithTooltip, {
      tooltip: this.displayedTooltip
    }, /*#__PURE__*/React.createElement("span", {
      ref: node => this.initInnerSpan(node),
      className: wrapTextClass,
      "data-test-id": this.props.dataTestId
    }, this.props.inline && /*#__PURE__*/React.createElement("span", {
      className: "ab-inline"
    }, this.props.label), !this.props.inline && this.props.label, this.props.children));
  }
  initOuterDiv(node) {
    if (node && node.parentNode) {
      this.outerDiv = node.parentNode;
    }
  }
  initInnerSpan(node) {
    this.innerSpan = node;
  }
  get displayedTooltip() {
    let tooltip = this.props.tooltip;
    if (!tooltip && this.outerDiv && this.innerSpan && this.outerDiv.scrollWidth < this.innerSpan.scrollWidth) {
      tooltip = this.innerSpan.innerText;
    }
    return tooltip;
  }
}
//# sourceMappingURL=AbLabel.js.map
